import MemeLogo from "../images/meme.png"
import memeClick from "./memebutton"

export default function MemeImage(props) {

    function mouseOver() {
        console.log("hovering!")
    }

    return (
        <div className="meme-image-container">
            <img src={props.image} alt="meme" className="meme-image" onMouseOver={mouseOver}></img>
        </div>
    )
}